export const CommentQueryGetter = Symbol('CommentQueryGetter');
export const CommentQuerySetter = Symbol('CommentQuerySetter');
